import styled from 'styled-components'

export const Wrapper = styled.div`
    flex-grow: 1;
    margin: 0 auto;
    position: relative;
    width: auto;
`


export const Container = styled.div`
    border-radius: 10px;
    //max-width: 500px;
`

export const Text = styled.div`
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 16px;
    color: #fff;
    text-align: left;
    
    &.style__break-word {
        word-break: break-word;
    }
`

export const GreyText = styled.div`
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 12px;
    color: #7D7D7D;
    text-align: left;
`

export const ButtonContainer = styled.div`
    display: flex;
    box-sizing: border-box;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    max-width: 490px;
    margin-top: 20px;
    margin-bottom: 20px;
`
export const Form = styled.form`
    width: 500px;
    margin: 0 auto;

    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
`

export const Title = styled.h3`
    
`

export const HeaderForgetContainer = styled.div`
    display: block;
    width: 100%;
    text-align: right;
`
export const HeaderForget = styled.div`
    text-align: right;
    display: inline-block;
    color: #4378FF;
    font-size: 14px;
    margin-right: 20px;
    margin-bottom: 10px;
    cursor: pointer;
`